import { Form, Input, Button, message, Modal, InputNumber, Select, Row, Col } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";

const { Option } = Select;

const opcionesVialidad = [
  "Autopistas y carreteras",
  "Vías de acceso controlado y vías rápidas",
  "Vías principales y ejes viales",
  "Vías primarias y colectoras",
  "Vías secundarias tipo A",
  "Vías secundarias tipo B",
  "Vías secundarias tipo C",
];

const opcionesEstacionamiento = [
  "Estacionamiento público abiertos",
  "Estacionamiento público cerrado o techado",
];

const opcionesPavimento = ["R1", "R2", "R3", "R4"];

export default function Nom013VialidadForm(props) {
  const { visible, title, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [form] = Form.useForm();
  const [tipoVialidad, setTipoVialidad] = useState(null);

  useEffect(() => {
    if (verification) {
      form.setFieldsValue(verification);
      setTipoVialidad(verification.TipoVialidad);
    }
  }, [verification, form]);

  const onFinish = (values) => {
    const verificationData = {
      ...verification,
      ...values,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, verificationData)
      .then(() => {
        message.success("Campos actualizados correctamente");
        setVerification(verificationData);
        setVisible(false);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al actualizar los campos");
      });
  };

  const handleTipoVialidadChange = (value) => {
    setTipoVialidad(value);
    form.setFieldsValue({ DetalleVialidad: null });
  };

  return (
    <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800} centered>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="TipoVialidad" label="Tipo de Vialidad">
          <Select onChange={handleTipoVialidadChange}>
            <Option value="Vialidad">Vialidad</Option>
            <Option value="Estacionamiento">Estacionamiento</Option>
          </Select>
        </Form.Item>
        <Form.Item name="DetalleVialidad" label="Detalle de Vialidad">
          <Select>
            {tipoVialidad === "Vialidad" &&
              opcionesVialidad.map((opcion) => (
                <Option key={opcion} value={opcion}>
                  {opcion}
                </Option>
              ))}
            {tipoVialidad === "Estacionamiento" &&
              opcionesEstacionamiento.map((opcion) => (
                <Option key={opcion} value={opcion}>
                  {opcion}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item name="TipoPavimento" label="Tipo de Pavimento">
          <Select>
            {opcionesPavimento.map((opcion) => (
              <Option key={opcion} value={opcion}>
                {opcion}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="AnchoVialidad" label="Ancho de Vialidad">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="LargoVialidad" label="Largo de Vialidad">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="DistanciaInterpostal" label="Distancia Interpostal">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Button type="primary" htmlType="submit">
          Guardar
        </Button>
      </Form>
    </Modal>
  );
}
